import { useCallback, useEffect, useMemo, useRef } from "react";
import { useRuntimeContext } from "../context/RuntimeContext";
import { useSlideStore } from "../store/useSlideStore";
import { debugLog } from "@/utils/debugLog";

const getSlideContext = () => {
  const { currentSlideIndex, slides } = useSlideStore.getState();
  const currentSlide = slides?.[currentSlideIndex];
  const slideUrl = currentSlide?.slide_html ?? "";
  const totalSlides = slides?.length ?? 0;
  const browserUrl = window.location.href;
  return { slideIndex: currentSlideIndex, totalSlides, slideUrl, browserUrl };
};

const useLogger = () => {
  const logRef = useRef([]);
  const { getDelta } = useRuntimeContext();
  const getDeltaRef = useRef(getDelta);

  useEffect(() => {
    getDeltaRef.current = getDelta;
  }, [getDelta]);

  const addLog = useCallback((message) => {
    const { slideIndex, totalSlides, slideUrl, browserUrl } = getSlideContext();
    const context = `[slide:${slideIndex}/${totalSlides}][page:${browserUrl}][slide_url:${slideUrl}]`;
    const delta = getDeltaRef.current();
    const logMessage = `[${delta}]${context} ${message}`;
    logRef.current.push(logMessage);
    debugLog(
      `%c[${delta}]${context} ${message}`,
      "color: cyan; font-weight: bold;",
    );
  }, []);

  const downloadLogs = useCallback(() => {
    const blob = new Blob([logRef.current.join("\n")], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "debug-log.txt";
    a.click();
    URL.revokeObjectURL(url);
  }, []);

  return useMemo(
    () => ({ logs: logRef.current, addLog, downloadLogs }),
    [addLog, downloadLogs],
  );
};

export default useLogger;
